import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { StocktakingItem } from 'entities/stocktaking_item'
import { ReactNode, useState } from 'react'
import { Form } from 'utils/hooks'
import { Button, Form as BSForm } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export const stocktakingItemColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 50, form: form, orderAttr: 'stocktaking_item_id', searchType: { name: 'id', type: 'multiple_text' } },
            { name: 'Probe', th: true, minWidth: 200, form: form, orderAttr: 'probe_name', searchType: { name: 'probe_name', type: 'text' } },
            { name: 'Box', th: true, width: 120, form: form, align: 'center', orderAttr: 'probe_box', searchType: { name: 'box', type: 'text' } },
            {
                name: '帳簿数',
                th: true,
                width: 80,
                form: form,
                align: 'center',
                orderAttr: 'stocktaking_item_book_count',
                searchType: { name: 'book_count', type: 'number' },
            },
            { name: '実地数', th: true, width: 80, align: 'center' },
            { name: '', th: true, width: 80, align: 'center' },
        ],
    }
}

export type StocktakingItemTableDataProps = {
    stocktakingItem?: StocktakingItem
    displaySetting: DisplaySetting
    onClick: (count: number) => void
    isCompleted?: boolean
}

export const StocktakingItemTableData = ({ stocktakingItem, displaySetting, onClick, isCompleted }: StocktakingItemTableDataProps): JSX.Element => {
    if (!stocktakingItem) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const [count, setCount] = useState<number>(
        stocktakingItem.physicalCount ?? (stocktakingItem.probe?.probeStocks?.filter((ps) => !ps.openedDate).length as number)
    )
    const [showUpdate, setShowUpdate] = useState<boolean>(false)

    const createCells = (
        <>
            <TableCell>{stocktakingItem.id}</TableCell>
            <TableCell>{stocktakingItem.probe?.name}</TableCell>
            <TableCell align="center">{stocktakingItem.probe?.box}</TableCell>
            <TableCell align="center" style={{ padding: '24px 10px' }}>
                <Link to={`/probe_stocks?probe_name=${stocktakingItem.probe?.name}`}>{stocktakingItem.bookCount}本</Link>
            </TableCell>
            <TableCell align="center">
                {(!stocktakingItem.completedAt || showUpdate) && !isCompleted ? (
                    <BSForm.Control
                        type="number"
                        style={{ marginBottom: 0, textAlign: 'center' }}
                        onChange={(e) => {
                            setCount(Number(e.target.value))
                        }}
                        min={0}
                        max={stocktakingItem.probe?.probeStocks?.filter((ps) => !ps.openedDate).length}
                        defaultValue={count}
                    />
                ) : (
                    <div style={{ position: 'relative' }}>
                        <div>{stocktakingItem.physicalCount}本</div>
                    </div>
                )}
            </TableCell>
            {isCompleted ? (
                <TableCell></TableCell>
            ) : (
                <TableCell align="center">
                    {!stocktakingItem.completedAt ? (
                        <Button
                            variant="success"
                            size="sm"
                            onClick={() => {
                                onClick(count)
                            }}
                        >
                            登録
                        </Button>
                    ) : showUpdate ? (
                        <Button
                            variant="success"
                            size="sm"
                            onClick={() => {
                                setShowUpdate(false)
                                onClick(count)
                            }}
                        >
                            更新
                        </Button>
                    ) : (
                        <Button
                            size="sm"
                            variant="secondary"
                            onClick={() => {
                                setShowUpdate(true)
                            }}
                        >
                            修正
                        </Button>
                    )}
                </TableCell>
            )}
        </>
    )

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
